// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__NRl7v","overlay":"Modal_overlay__NqPJ9"};